import MentionCards from "@components/MentionCards";
import { useQuery } from "@tanstack/react-query";
import { getSearchMentionsV4 } from "@/api/endpoints/searches";
import { usePageParam } from "@/hooks/usePageParam";
import { Trans } from "@lingui/react/macro";
import { SearchFilterV4WithDates } from "@/types/SearchFilter";
import { SORTING_OPTION } from "@/constants";
import { ALL_SENTIMENTS_BUT_NEUTRAL } from "@/utils/sentiment";

export default function MentionsInsightsSentimentViewMentionCards({
  searchUuid,
  orgUuid,
  filters,
}: {
  filters: SearchFilterV4WithDates;
  searchUuid: Uuid;
  orgUuid: Uuid;
}) {
  // URL state
  const [page, setPage] = usePageParam();

  // Server state
  const {
    data: mentionCardsData,
    isLoading: isMentionCardsLoading,
    error: mentionCardsError,
  } = useQuery({
    queryKey: [
      "searches",
      searchUuid,
      "insights-sentiment",
      "mention-cards",
      filters,
      page,
    ],
    queryFn: () => {
      return getSearchMentionsV4(searchUuid, {
        ...filters,
        page,
        sentiment: Array.isArray(filters.sentiment)
          ? filters.sentiment.length
            ? filters.sentiment
            : ALL_SENTIMENTS_BUT_NEUTRAL
          : (filters.sentiment ?? ALL_SENTIMENTS_BUT_NEUTRAL),
        sort_by: SORTING_OPTION.REACH,
      });
    },
  });

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-semibold">
          <Trans>Träffar som påverkar sentimentet</Trans>
        </h2>

        <p className="text-sm text-muted-foreground text-balance">
          <Trans>Rankade efter räckvidd & datum</Trans>
        </p>
      </div>

      <MentionCards
        isMentionCardsLoading={isMentionCardsLoading}
        mentionCardsError={mentionCardsError}
        mentionCardsData={mentionCardsData}
        onChangePage={setPage}
        orgUuid={orgUuid}
        page={page}
      />
    </div>
  );
}
